var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactQuestionFactory, SurveyQuestionElementBase } from "survey-react-ui";
import { editorLocalization } from "survey-creator-core";
import { ActionButton } from "./ActionButton";
var SurveyQuestionLinkValue = /** @class */ (function (_super) {
    __extends(SurveyQuestionLinkValue, _super);
    function SurveyQuestionLinkValue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyQuestionLinkValue.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionLinkValue.prototype.renderClear = function () {
        var _this = this;
        var showClear = this.questionBase.showClear;
        if (!this.questionBase.isReadOnly && showClear) {
            return (React.createElement(ActionButton, { classes: this.question.linkClearButtonCssClasses, click: function () { return _this.question.doClearClick(); }, text: editorLocalization.getString("pe.clear") }));
        }
        else {
            return null;
        }
    };
    SurveyQuestionLinkValue.prototype.renderElement = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(ActionButton, { classes: this.question.linkSetButtonCssClasses, click: function () { return _this.question.doLinkClick(); }, selected: this.question.isSelected, disabled: !this.question.isClickable, text: this.question.linkValueText, title: this.question.tooltip, iconName: this.question.iconName }),
            this.renderClear()));
    };
    return SurveyQuestionLinkValue;
}(SurveyQuestionElementBase));
export { SurveyQuestionLinkValue };
ReactQuestionFactory.Instance.registerQuestion("linkvalue", function (props) {
    return React.createElement(SurveyQuestionLinkValue, props);
});
